module.exports = __webpack_public_path__ + "static/media/user.c654f121.png";